
import { branch, renderNothing } from 'recompose';

export default branch(({ children }) => !children || !children.length, renderNothing);
